/** Painel padrão (borda + sombra s1). `Card` envolve; `CardHeader` = título + ação. */
import { createElement as h, type ReactElement, type ReactNode } from "react";
import { cx } from "./cx.js";

export interface CardProps {
  children?: ReactNode;
  className?: string;
  "aria-label"?: string;
  [dataAttr: `data-${string}`]: string | number | boolean | undefined;
}

export function Card({ children, className, ...rest }: CardProps): ReactElement {
  return h(
    "section",
    { ...rest, className: cx("min-w-0 rounded-panel border border-border bg-surface p-5 shadow-s1", className) },
    children
  );
}

export interface CardHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
}

export function CardHeader({ title, description, actions }: CardHeaderProps): ReactElement {
  return h(
    "div",
    { className: "mb-4 flex flex-wrap items-start justify-between gap-3" },
    h(
      "div",
      { className: "min-w-0" },
      h("h2", { className: "text-lg font-extrabold text-ink" }, title),
      description ? h("p", { className: "mt-1 text-sm text-muted" }, description) : null
    ),
    actions ? h("div", { className: "flex items-center gap-2" }, actions) : null
  );
}
